export default __webpack_public_path__ + "static/media/close-eye.3ab32b96.svg";